export class LogotypeViewEvents {
	public static readonly LOGOTYPE_DOUBLE_TAPPED: string = 'LogotypeViewEvents::LOGOTYPE_DOUBLE_TAPPED';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/logotype/LogotypeViewEvents.ts